import React, { useEffect } from 'react'
import { Box, Heading } from 'grommet'
import { useBugfixList } from '../../hooks'
import { PacmanLoader } from 'react-spinners'
import { qlikBrand } from '../../branding'
import ProjectCard from '../../components/ProjectCard'

const renderBugfixProjects = ({ bugfixProjects, fetchBugfixListInProgress, toggleBug }) => {
  if (fetchBugfixListInProgress) {
    return null
  }
  if (!bugfixProjects.length) {
    return (
      <Box align='center'>No projects!</Box>
    )
  } else {
    return (
      <Box align='center'>
        {bugfixProjects.map((project, index) => (
          <ProjectCard key={project._id} project={project} toggleBug={toggleBug} projectIndex={index} />
        ))}
      </Box>
    )
  }
}

function BugfixProjectList() {
  const {
    bugfixList,
    fetchBugfixListInProgress,
    fetchBugfixList,
    toggleBug
  } = useBugfixList()

  useEffect(() => {
    fetchBugfixList()
  }, [fetchBugfixList])

  return (
    <Box align='stretch' fill='horizontal' jusify='center'>
      <Box align='center'><Heading level='2'>Bugfix Projects</Heading></Box>
      <Box align='center'><PacmanLoader
        loading={fetchBugfixListInProgress}
        color={qlikBrand.core.green}
        sizeUnit='px'
        size={50}
      /></Box>
      {renderBugfixProjects({
        bugfixProjects: bugfixList,
        fetchBugfixListInProgress,
        toggleBug
      })}
    </Box>
  )
}

export default BugfixProjectList
